import { Layout } from 'components/Layout'
import styled from 'styled-components'

export const Dashboard = () => {
  return (
    <Layout>
      <Div>
        <p>Please contact Customer Support to update your Claims Work Console access permissions</p>
      </Div>
    </Layout>
  )
}

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.5rem;
  font-weight: 600;
`
